<template>
  <div v-show="len" class="pages-tables ">
    <table class="table1" cellpadding="0" cellspacing="0">
      <tr>
        <th>{{ type == 1 ? '日期' : '月份' }}</th>
      </tr>
      <tr v-for="(l,i) in yList" :key="i">
        <td>{{l.statis_date | dateFromt}}</td>
      </tr>
      <tr></tr>
    </table>
    <div class="tables-active2">
      <table class="table2" cellpadding="0" cellspacing="0">
        <tr>
          <th v-for="(l,i) in xList" :key="i">{{l.zx_name}}</th>
        </tr>
        <tr v-for="(l,i) in yList" :key="i">
          <td v-for="(x,xKey) in xDataXList" :key="xKey">
            <div v-if="x === yKey" v-for="(ll,yKey) in l" :key="yKey" :class="{'tables-content-item-yellow':yList[i][yKey] > 0 && validateVal(x),'tables-content-item-green':yList[i][yKey] <= 0 && validateVal(x),}">
              {{ yList[i][yKey]}}
            </div>
          </td>
        </tr>
        <tr></tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ['xList', 'yList', 'xDataXList','type'],
  data () {
    return {
      len: 0,
      flex: 1,
      showTable: false,
      dateType:'日期'
    }
  },
  watch: {
    xDataXList () {
      this.len = this.xDataXList.length
    }
  },
  methods: {
    // 返回
    vdVal (val, value) {
      return value
    },
    // 是否包含 % 标志，有就要颜色控制
    validateVal (value) {
      let flag = false
      this.xList.forEach((e, i) => {
        if (e.zd_name == value) {
          if (e.zx_name.includes('%')) {
            flag = true
          }
        }
      })
      return flag
    },
    clickCity (id) {
      // this.$emit('change', id)
    },
    // 控制两个div同意上下滚动
    fllowScroll () {
      let preview = document.querySelector('#tablesList1');
      let editor = document.querySelector('#tablesList2');
      preview.addEventListener('scroll', (e) => {
        e.stopPropagation();
        editor.scrollTop = preview.scrollTop;
      });

      editor.addEventListener('scroll', (e) => {
        e.stopPropagation();
        preview.scrollTop = editor.scrollTop;
      });
    }
  },
  filters: {
    dateFromt: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.slice(4)
    },
  },
  mounted () {
    
    // this.len = this.xDataXList.length
    // this.showTable = true
    // this.fllowScroll()
  }
}

</script>
<style lang="less" scoped>
@main-color-green: #269513;
@main-color-yellow: #fc9d2e;

.pages-tables {
  -webkit-overflow-scrolling: touch; // ios滑动顺畅
  position: relative;
}
table td {
  border: 0px solid #000;
  font-size: 0.32rem;
}

.table1 {
  width: 1.5rem;
}
.table1,
.table2 {
  color: #86939e;
  font-size: 0.32rem;
  border: 0px solid #000;
  min-height: 100%;
  text-align: center;
  td {
    border-bottom: 0.02rem solid #eee;
    white-space: nowrap;
    height: 0.86rem;
    line-height: 0.86rem;
    padding: 0 0.2rem;
  }
  th {
    color: #43484d;
    white-space: nowrap;
    height: 0.74rem;
    line-height: 0.74rem;
    padding: 0rem 0.3rem;
    background-color: #f3f4f6;
    font-weight: normal;
    padding-bottom: 0;
    padding-top: 0;
  }
}

.table2 {
  min-width: 6.5rem;
  position: absolute;
  left: 0rem;
  // overflow-x: scroll;
}

.tables-active2 {
  width: 6.1rem;
  position: absolute;
  top: 0;
  left: 1.4rem;
  overflow-x: scroll;
  min-height: 100%; // min-height: 4rem;
}

.tables-content-item-green {
  color: @main-color-green;
}

.tables-content-item-yellow {
  color: @main-color-yellow;
}
</style>



// WEBPACK FOOTER //
// src/components/app/add/tables.vue